<mat-card appearance="outlined" class="login-card">
  <mat-card-header class="matCardHeader">
    <mat-card-title>
      <h1>{{'auth.login.title' | translate}}</h1>
    </mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
      <mat-form-field appearance="outline">
        <mat-label>{{'auth.login.username.label' | translate}}</mat-label>
        <input type="text" matInput formControlName="username">
        <mat-error>{{'auth.login.username.errorMessage' | translate}}</mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>{{'auth.login.password.label' | translate}}</mat-label>
        <input type="password" matInput formControlName="password">
        <mat-error>{{'auth.login.password.errorMessage' | translate}}</mat-error>
      </mat-form-field>

      <div class="passwordLinkContainer">
        <a routerLink="/login/forgot-password" class="passwordLink">{{'auth.forgotPassword' | translate}}</a>
      </div>

      <button type="submit" mat-raised-button color="primary" *ngIf="!isLoading"
        [disabled]="loginForm.invalid">{{'auth.login.actions.login' | translate}}</button>
      <mat-spinner *ngIf="isLoading" [diameter]="35" color="primary"></mat-spinner>
    </form>
  </mat-card-content>
</mat-card>
<div class="contactWrapper">
  <p>Vous souhaitez accéder à notre espace client ?</p>
  <a href="https://ftso.fr/contact/" *ngIf="!envName.includes('hemo')">Contactez-nous</a>
  <a href="https://hemo-services.com/contact/" *ngIf="envName.includes('hemo')">Contactez-nous</a>
</div>